export const userLoginReducer = (state = {}, action) => {
  switch (action.type) {
    case "USER_LOGIN_REQUEST":
      return { loading: true };
    case "USER_LOGIN_SUCCESS":
      return { loading: false, userInfo: action.payload };
    case "USER_LOGIN_FAIL":
      return { loading: false, error: action.payload };
    case "USER_UPDATE_PLAN":
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          currentPlanId: action.payload.currentPlanId,
          planId: action.payload.currentPlanId,
          ...(state.userInfo?.user && {
            user: {
              ...state.userInfo.user,
              currentPlanId: action.payload.currentPlanId,
              planId: action.payload.currentPlanId,
            },
          }),
        },
      };
    case "USER_UPDATE_PLAN_EXPIRATION":
      return {
        ...state,
        userInfo: {
          ...state.userInfo,
          planExpiration: action.payload.planExpiration,
          ...(state.userInfo?.user && {
            user: {
              ...state.userInfo.user,
              planExpiration: action.payload.planExpiration,
            },
          }),
        },
      };
    case "USER_LOGIN_RESET":
      return {};
    case "USER_LOGOUT":
      return {};
    default:
      return state;
  }
};

export const userSignUpReducer = (state = {}, action) => {
  switch (action.type) {
    case "USER_SIGNUP_REQUEST":
      return { loading: true };
    case "USER_SIGNUP_SUCCESS":
      return {
        loading: false,
        message: action.payload.data,
        status: action.payload.status,
      };
    case "USER_SIGNUP_FAIL":
      return { loading: false, errorMessage: action.payload };
    case "USER_SIGNUP_RESET":
      return {};
    default:
      return state;
  }
};
